export const personalInfo = {
  name: "Abhilash Puljal",
  title: "Strategy Advisor",
  subtitle: "Partner & Country Director, Expectation State | Co-Director, LSE Foundation India",
  tagline: "Delivering sustainable projects for public and private sector clients globally for over 23 years.",
  shortBio: "Abhilash Puljal is a seasoned strategy advisor with over 23 years of experience delivering sustainable projects for public and private sector clients globally. With a proven track record in government relations, international strategy, organizational design, and economic development across diverse sectors, he has worked with some of the world's most prestigious institutions.",
  fullBio: [
    "Abhilash Puljal is an experienced strategy advisor with over 23 years of experience delivering sustainable projects for public and private sector clients globally. He has a proven track record in government, international relations, strategy, organizational design, and economic development across diverse sectors.",
    "With strong business development and client relationship management skills, Abhilash has worked with some of the world's most prestigious organizations including the World Bank, United Nations World Food Programme, European Union, GIZ, International Trade Centre, and PricewaterhouseCoopers.",
    "Currently serving as Partner and Country Director at Expectation State Limited, spearheading the India, South, and Southeast Asia Practice, and as Co-Director of the LSE Research and Education Foundation India, promoting the Foundation's mission of education and research excellence.",
    "Abhilash is also the Founder of The Purple Patch Trust, an animal shelter in Delhi NCR dedicated to animal welfare. He lives between New Delhi, Goa and Hyderabad, India."
  ],
  contact: {
    email: "abhilash.puljal@gmail.com",
    emailWork: "abhilash.puljal@expectationstate.com",
    emailAcademic: "a.puljal@lse.ac.uk",
    phone: "+91 98711 33726",
    phoneUK: "+44 74955 33922",
    address: "New Delhi, India",
    website: "www.abhilash.com"
  },
  social: {
    linkedin: "https://www.linkedin.com/in/puljal"
  }
};

export const currentRoles = [
  {
    title: "Partner & Country Director",
    organization: "Expectation State Limited",
    location: "London, UK",
    period: "2024 – Present",
    description: "Spearheading India, South, and Southeast Asia Practice. Driving strategic growth, operational excellence, brand visibility, and revenue growth."
  },
  {
    title: "Co-Director",
    organization: "LSE Research & Education India Foundation",
    location: "Mumbai & New Delhi, India",
    period: "2021 – Present",
    description: "Promoting the LSE Foundation India, spearheading fundraising for underprivileged student scholarships, and fostering research collaborations."
  },
  {
    title: "Founder",
    organization: "The Purple Patch Trust",
    location: "Delhi NCR, India",
    period: "",
    description: "An animal shelter dedicated to the welfare and rescue of animals in the Delhi NCR region."
  }
];

export const expertise = [
  { name: "Trade Facilitation & Strategy", icon: "Globe" },
  { name: "Policy Design & Advisory", icon: "FileText" },
  { name: "Value Chain Analysis", icon: "Link2" },
  { name: "Government Relations", icon: "Building2" },
  { name: "Business Development", icon: "TrendingUp" },
  { name: "Private Sector Development", icon: "Briefcase" },
  { name: "Cross-Border Investment", icon: "ArrowLeftRight" },
  { name: "International Development", icon: "Globe" },
  { name: "Digital Public Infrastructure", icon: "Monitor" },
  { name: "Regional Cooperation", icon: "Users" },
  { name: "Sustainability", icon: "Leaf" },
  { name: "Macro Economic Strategy", icon: "BarChart3" }
];

export const focusSectors = [
  "Agriculture & Agri-business",
  "Pharmaceutical Strategy",
  "Education & Capacity Building",
  "Infrastructure & Logistics",
  "Circular Economy",
  "Renewable Energy & Sustainability",
  "Healthcare",
  "Defence Research & Manufacturing",
  "Digital Public Infrastructure"
];

export const clients = [
  { name: "World Bank", short: "World Bank" },
  { name: "United Nations World Food Programme", short: "UN WFP" },
  { name: "European Union", short: "European Union" },
  { name: "Deutsche Gesellschaft für Internationale Zusammenarbeit", short: "GIZ" },
  { name: "International Trade Centre", short: "ITC Geneva" },
  { name: "PricewaterhouseCoopers", short: "PwC" },
  { name: "UKAID", short: "UKAID" },
  { name: "African Export-Import Bank", short: "Afreximbank" },
  { name: "African Development Bank", short: "AfDB" },
  { name: "Grant Thornton", short: "Grant Thornton" },
  { name: "USAID", short: "USAID" },
  { name: "LuxDev", short: "LuxDev" },
  { name: "UNHCR", short: "UNHCR" },
  { name: "Government of Zambia", short: "Govt. of Zambia" },
  { name: "Government of Rwanda", short: "Govt. of Rwanda" },
  { name: "Government of Gabon", short: "Govt. of Gabon" },
  { name: "Government of Sri Lanka", short: "Govt. of Sri Lanka" },
  { name: "Government of India – Bihar", short: "Govt. of India" },
  { name: "EU Delegation to India", short: "EU Delegation India" },
  { name: "Particip GmbH", short: "Particip GmbH" },
  { name: "Olam International", short: "Olam International" },
  { name: "Kalp Foundation", short: "Kalp Foundation" }
];

export const experience = [
  {
    title: "Partner & Country Director",
    organization: "Expectation State Limited",
    location: "London, UK",
    period: "Apr 2024 – Present",
    description: "Spearheading India, South, and Southeast Asia Practice. Driving strategic growth, operational excellence, and business development.",
    highlights: [
      "Business Case Development Expert – Sustainable Forestry and Renewable Energy Programme, LuxDev Rwanda",
      "Team Lead – Enhancing Financial Inclusion for Forcibly Displaced People, UNHCR Uganda"
    ]
  },
  {
    title: "Advisor – Value Chain Expert",
    organization: "United Nations World Food Programme",
    location: "New Delhi, India",
    period: "Nov 2024 – Oct 2025",
    description: "Devised value chain analysis methodologies, identified and profiled commodities for value chain development, and executed studies of high-growth value chains.",
    highlights: []
  },
  {
    title: "Director – Global Affairs",
    organization: "Mai Labs Private Limited (Kalp Foundation)",
    location: "New Delhi, India & San Francisco, USA",
    period: "Nov 2024 – Sep 2025",
    description: "Spearheading development of new markets across Africa and Asia, leading negotiations with governments, and securing financial support through grant fundraising.",
    highlights: []
  },
  {
    title: "Co-Director",
    organization: "LSE Research & Education India Foundation",
    location: "Mumbai & New Delhi, India",
    period: "Jan 2021 – Present",
    description: "Promoting the LSE Foundation India, facilitating establishment and operational launch, spearheading fundraising for underprivileged student scholarships.",
    highlights: []
  },
  {
    title: "Cross Border Strategy & Fund Raise Lead",
    organization: "Provenio Astral International LLP",
    location: "India, Singapore & Vietnam",
    period: "Jan 2023 – Feb 2024",
    description: "Devised cross-border investment strategy for pharmaceutical manufacturing in Vietnam. Led negotiations for fiscal and non-fiscal benefits.",
    highlights: []
  },
  {
    title: "South-South & Triangular Cooperation Expert",
    organization: "United Nations World Food Programme",
    location: "New Delhi, India",
    period: "Jul 2022 – Mar 2024",
    description: "Conducted needs-based assessment and gap analysis for countries in Africa and Asia. Identified countries to leverage India's expertise in millet value chain.",
    highlights: []
  },
  {
    title: "Senior Non-Key Expert",
    organization: "Particip GmbH",
    location: "Freiburg, Germany",
    period: "Dec 2021 – Jul 2022",
    description: "Mapped trade between EU and India, identified key sectors for trade and biodiversity, and developed proxies for traceability and monitoring of green trade.",
    highlights: []
  },
  {
    title: "Project Lead",
    organization: "The African Export Import Bank",
    location: "Cairo, Egypt",
    period: "May 2021 – Aug 2022",
    description: "Designed and implemented training programme on Export Trading Companies across several African countries. Developed programme content on AfCFTA.",
    highlights: []
  },
  {
    title: "Lead Strategist",
    organization: "Deutsche Gesellschaft für Internationale Zusammenarbeit (GIZ)",
    location: "Brussels, Belgium",
    period: "Jan 2019 – May 2021",
    description: "Designed Trilateral Development Strategy between India, the EU, and Africa. Identified geopolitically important African countries for cooperation.",
    highlights: []
  },
  {
    title: "Project Coordinator & Lead Strategist",
    organization: "Ministry of Commerce, Government of Zambia",
    location: "Lusaka, Zambia",
    period: "Jun 2019 – Oct 2022",
    description: "Drafted development strategy for the Lobito Corridor Trade Facilitation. Identified legal and regulatory issues impacting cross-border trade.",
    highlights: []
  },
  {
    title: "Lead Expert – Development Strategy & Trade",
    organization: "Olam Gabon / Gabon SEZ",
    location: "Libreville, Gabon",
    period: "Apr 2018 – Jan 2020",
    description: "Advised on bilateral trade policy matters, reviewed bilateral agreements, and provided trade advisory on improving export products and investment strategy.",
    highlights: []
  },
  {
    title: "International Consultant – Trade Strategy",
    organization: "International Trade Centre",
    location: "Geneva, Switzerland",
    period: "May 2017 – Jan 2018",
    description: "Designed and drafted the National Export Strategy for Sri Lanka. Conducted national and regional level consultations.",
    highlights: []
  },
  {
    title: "Private Sector Development & SME Expert",
    organization: "PricewaterhouseCoopers",
    location: "New Delhi, India",
    period: "Jun 2016 – Jun 2018",
    description: "Advised on Private Sector Development and SME development initiative for GROW Bihar. Provided strategic guidance to strengthen Bihar's policy framework.",
    highlights: []
  },
  {
    title: "Promoter & Managing Director",
    organization: "Avignam Advisors",
    location: "India",
    period: "Aug 2010 – Jul 2015",
    description: "Promoted Avignam Group with a vision to alleviate poverty through private sector development and South-South agenda.",
    highlights: []
  },
  {
    title: "Senior Consultant – Tax & Regulatory",
    organization: "PricewaterhouseCoopers",
    location: "New Delhi, India",
    period: "Dec 2007 – Jul 2010",
    description: "Provided expert advice on India's inbound investment policies. Structured India entry strategies and conducted regulatory due diligence.",
    highlights: []
  },
  {
    title: "Assistant Vice President",
    organization: "SKIL Infrastructure Limited",
    location: "Mumbai, India",
    period: "Dec 2006 – Nov 2007",
    description: "Contributed to corporate strategy focusing on SEZs, Shipyards, and Airports. Developed business strategies for new infrastructure projects.",
    highlights: []
  }
];

export const education = [
  {
    degree: "Master of Science in Development Management",
    institution: "London School of Economics and Political Science",
    location: "London, UK",
    period: "2005 – 2006"
  },
  {
    degree: "Master of International Business",
    institution: "University of Sydney",
    location: "Sydney, Australia",
    period: "2003 – 2005",
    note: "Minor in Political Science"
  },
  {
    degree: "Bachelor of Science in Commerce",
    institution: "DePaul University",
    location: "Chicago, IL, USA",
    period: "2000 – 2002",
    note: "Major in Management, Minor in Political Science, Specialisation in Entrepreneurship"
  },
  {
    degree: "Study Abroad Programme",
    institution: "Plekhanov Russian Academy of Economics",
    location: "Moscow, Russia",
    period: "2001"
  }
];

export const publications = [
  { title: "Animals were no one's priority in the Delhi floods", publication: "The Sunday Guardian", date: "July 2023" },
  { title: "Stronger Together: A Collection of Essays on Rising Rwanda & Strategic Partnership with India", publication: "India Rwanda Friendship Association", date: "July 2022", coAuthors: "Pranjal Sharma" },
  { title: "Cross-border investments in an evolving global marketplace", publication: "E-Newsletter, IMCI", date: "June 2019" },
  { title: "Spices and concentrates strategy", publication: "National Export Strategy of Sri Lanka 2018-20, Government of Sri Lanka", date: "July 2018" },
  { title: "Electronic and electrical component strategy", publication: "National Export Strategy of Sri Lanka 2018-20, Government of Sri Lanka", date: "July 2018" },
  { title: "Trade information and promotion strategy", publication: "National Export Strategy of Sri Lanka, Government of Sri Lanka", date: "July 2018" },
  { title: "Regional economic cooperation and Indian efforts", publication: "Scholar Warrior, Centre for Land Warfare Studies (CLAWS)", date: "Autumn 2017" },
  { title: "Book review – Half Lion: How P.V. Narasimha Rao Transformed India", publication: "LSE Review of Books", date: "August 2016" },
  { title: "Mutual benefits for SMEs", publication: "The Economic Times", date: "October 2015" },
  { title: "Liberation and liberalisation: Private Sector Development in Rwanda", publication: "Government of Rwanda Publication", date: "July 2014" },
  { title: "Business Guide to Investing in Africa 2014", publication: "Confederation of Indian Industries (CII) Africa Conferences", date: "July 2014" },
  { title: "Rwanda: from genocide to growth miracle", publication: "The Hindu Business Line", date: "January 2014", coAuthors: "Aparupa Chakravarti" },
  { title: "India Remembers Madiba", publication: "India Africa Connect", date: "December 2013" },
  { title: "Waka, Waka for Indian SMEs", publication: "The Hindu Business Line", date: "October 2013" },
  { title: "In the dark about Africa", publication: "The Hindu Business Line", date: "May 2013" },
  { title: "Unpublished Kotalingala Coins and a Discussion on Ujjain Symbol", publication: "Journal of the Numismatic Society of India, BHU", date: "2007", coAuthors: "Deme Raja Reddy" },
  { title: "Double Obverse Coins in the Singavaram Hoard", publication: "Journal of the Numismatic Society of India, BHU", date: "2006", coAuthors: "Deme Raja Reddy" },
  { title: "Andhra Janapada Coins of Singavaram", publication: "ONS Newsletter, Oriental Numismatic Society, London", date: "2005", coAuthors: "Deme Raja Reddy" },
  { title: "A brief History of Asaf Jah Coins and their Mints", publication: "Journal of the Numismatic Society of India, BHU", date: "2003", coAuthors: "Deme Raja Reddy" }
];

export const certifications = [
  { title: "Certified Management Consultant (CMC®)", institution: "Institute of Management Consultants of India (IMCI)" },
  { title: "Market Systems Approach", institution: "Springfield Centre, Durham, UK" },
  { title: "Certificate on SME Exports", institution: "International Trade Centre, Geneva" },
  { title: "Advanced Security in the Field", institution: "United Nations Department of Safety and Security" },
  { title: "BSafe Certification", institution: "United Nations Department of Safety and Security" }
];

export const memberships = [
  { title: "Certified Management Consultant (CMC®)", organization: "IMCI, Mumbai" },
  { title: "Life Member", organization: "Ananta Aspen Centre" },
  { title: "Member", organization: "The Royal Economic Society, London" },
  { title: "Life Member", organization: "All India Management Association" },
  { title: "Registered Consultant", organization: "Asian Development Bank, African Development Bank, World Bank, UN WFP" },
  { title: "Member", organization: "India International Centre, New Delhi" },
  { title: "Life Member", organization: "Association of British Scholars, New Delhi" },
  { title: "Fellow", organization: "The Royal Numismatic Society, London" },
  { title: "Life Member", organization: "Numismatic Society of India, BHU" },
  { title: "Life Member", organization: "Delhi Management Association" }
];

export const awards = [
  { title: "LSE Alumni Award 2025", institution: "London School of Economics and Political Science", year: "2025" },
  { title: "Leo V. Ryan Scholarship", institution: "DePaul University, Chicago", year: "2001" },
  { title: "Student Leadership Award", institution: "Northern Illinois University", year: "1998" }
];

export const visitedCountries = {
  "356": "India",
  "840": "United States",
  "050": "Bangladesh",
  "116": "Cambodia",
  "036": "Australia",
  "826": "United Kingdom",
  "288": "Ghana",
  "231": "Ethiopia",
  "646": "Rwanda",
  "180": "DR Congo",
  "800": "Uganda",
  "404": "Kenya",
  "834": "Tanzania",
  "480": "Mauritius",
  "784": "United Arab Emirates",
  "266": "Gabon",
  "144": "Sri Lanka",
  "458": "Malaysia",
  "894": "Zambia",
  "024": "Angola",
  "384": "Côte d'Ivoire",
  "854": "Burkina Faso",
  "818": "Egypt",
  "710": "South Africa",
  "566": "Nigeria",
  "072": "Botswana",
  "704": "Vietnam",
  "270": "The Gambia",
  "430": "Liberia",
  "324": "Guinea",
  "148": "Chad",
  "643": "Russia",
  "276": "Germany",
  "056": "Belgium",
  "756": "Switzerland",
  "702": "Singapore",
  "686": "Senegal"
};

export const stats = {
  countries: "37+",
  continents: "5",
  yearsExperience: "23+",
  clients: "50+"
};

export const newsTopics = [
  { id: "1", headline: "India-Africa Trade Corridor: New Opportunities in South-South Cooperation", category: "Trade" },
  { id: "2", headline: "Digital Public Infrastructure: Transforming Emerging Economies Across Asia & Africa", category: "Technology" },
  { id: "3", headline: "AfCFTA Implementation: Accelerating Intra-African Trade & Investment", category: "Policy" },
  { id: "4", headline: "Sustainable Agriculture Value Chains: From Farm to Global Markets", category: "Agriculture" },
  { id: "5", headline: "Trilateral Development Cooperation: EU, India & Africa Forge New Partnerships", category: "Development" },
  { id: "6", headline: "Renewable Energy Transition: Policy Frameworks for Developing Nations", category: "Energy" },
  { id: "7", headline: "Cross-Border Investment in Pharmaceutical Manufacturing Across Southeast Asia", category: "Investment" },
  { id: "8", headline: "Millet Value Chain Development: India's Expertise Goes Global", category: "Agriculture" }
];

export const countryProjects = {
  "356": "Led multiple projects including value chain analysis for UN WFP, South-South Cooperation initiatives, and private sector development advisory for GROW Bihar with PwC.",
  "840": "Directed Global Affairs for Kalp Foundation, leading digital public infrastructure initiatives and securing government partnerships across emerging markets.",
  "826": "Partner & Country Director at Expectation State. Co-Director of LSE Research & Education Foundation India, fostering academic collaborations.",
  "894": "Drafted development strategy for the Lobito Corridor Trade Facilitation. Identified legal and regulatory issues impacting cross-border trade for the Government of Zambia.",
  "646": "Business Case Development Expert for Sustainable Forestry and Renewable Energy Programme with LuxDev Rwanda. Co-edited essays on India-Rwanda partnership.",
  "288": "Worked on trade facilitation and private sector development initiatives across West Africa, including Export Trading Company training programmes.",
  "231": "Conducted needs-based assessments for millet value chain development and South-South Cooperation in the Horn of Africa for UN WFP.",
  "818": "Project Lead at African Export Import Bank, designing and implementing Export Trading Company training programmes and AfCFTA content.",
  "266": "Lead Expert for Olam Gabon SEZ, advising on bilateral trade policy, reviewing agreements, and providing investment strategy advisory.",
  "144": "Designed and drafted the National Export Strategy for Sri Lanka covering spices, electronics, and trade promotion with ITC Geneva.",
  "056": "Designed Trilateral Development Strategy between India, the EU, and Africa for GIZ Brussels, identifying key African countries for cooperation.",
  "756": "International Consultant at ITC Geneva on trade strategy, sector development, and national export strategy design.",
  "276": "Senior Non-Key Expert at Particip GmbH, mapping EU-India trade for biodiversity and green trade monitoring.",
  "704": "Devised cross-border investment strategy for pharmaceutical manufacturing in Vietnam with Provenio Astral.",
  "702": "Led cross-border strategy and fund-raising across Asia-Pacific markets for pharmaceutical sector development.",
  "116": "Value chain development and trade facilitation initiatives in Southeast Asia through South-South Cooperation.",
  "050": "South-South Cooperation expert, leveraging India's expertise in millet and agriculture for development in Bangladesh.",
  "710": "Strategic advisory on bilateral trade, private sector development, and cross-border investment in Southern Africa.",
  "566": "Trade facilitation and Export Trading Company training programmes across West Africa for Afreximbank.",
  "036": "Master of International Business at University of Sydney, with Minor in Political Science.",
  "643": "Study Abroad Programme at Plekhanov Russian Academy of Economics, Moscow.",
  "800": "Team Lead for UNHCR project on Enhancing Financial Inclusion for Forcibly Displaced People in Uganda.",
  "404": "South-South & Triangular Cooperation initiatives for UN WFP, capacity building in East Africa.",
  "834": "Value chain development and trade capacity building initiatives in East Africa for UN WFP.",
  "480": "Trade policy advisory and regional cooperation initiatives in the Indian Ocean region.",
  "784": "International strategy and cross-border investment advisory in the Gulf region.",
  "458": "Private sector development and trade facilitation initiatives in Southeast Asia.",
  "072": "Lead Advisor at Pula Dynes & Strategies on trade competitiveness and economic development in Botswana.",
  "024": "Trade facilitation and Lobito Corridor development initiatives in Angola.",
  "180": "South-South cooperation and value chain development projects in the Democratic Republic of Congo.",
  "384": "Export Trading Company training and West African trade development for Afreximbank.",
  "854": "Trade capacity building and private sector development advisory in Burkina Faso.",
  "270": "Export Trading Company training programmes across West Africa.",
  "430": "Trade facilitation and private sector development advisory in Liberia.",
  "324": "Trade capacity building and development initiatives in the Republic of Guinea.",
  "148": "Trade facilitation and development strategy advisory in Chad.",
  "686": "South-South cooperation and regional trade development in Senegal."
};

export const profileUrl = "https://customer-assets.emergentagent.com/job_f1940992-6af1-46cc-801d-40266a913ae9/artifacts/4888uqea_Profile-AbhilashPuljal.pdf";

export const images = {
  consulting: "https://images.unsplash.com/photo-1565688527174-775059ac429c?w=800&q=80",
  diplomatic: "https://images.unsplash.com/photo-1713930517076-18a9fd284cfb?w=800&q=80",
  university: "https://images.unsplash.com/photo-1759734353125-6913ba6c6804?w=800&q=80",
  cityscape: "https://images.pexels.com/photos/34092/pexels-photo.jpg?auto=compress&cs=tinysrgb&w=800"
};